import { BaseSolitaireLayout, ISolitaireLayoutOutput } from "../baseSolitaireLayout";
import { ScorpionSolitaire } from "./scorpionSolitaire";

export class ScorpionColumnsAndLeftovers extends BaseSolitaireLayout<ScorpionSolitaire> implements ISolitaireLayoutOutput<ScorpionSolitaire> {
    leftovers!: number[];
    faceDownCards!: number[][];
}